import React, { useEffect, useState } from "react";
 


import MarqueDetails from "./MarqueDetails";
import MarqueDetailsPreview from "./MarqueDetailsPreview";
import { useKeycloak } from "@react-keycloak/web";
import { useFetchSocieteQuery } from "../../../redux/slice/api/FO/societeApi";
import { useNavigate, useParams } from "react-router-dom";
import MessageView from "../components/message/MessageView";
import { MessageTypeDemande, MessageTypeView, Type_Reponse_Message } from "../../../config/helpers";
import { useCreatemessageMutation, useDeletemessageMutation, useLazyFetchmessageQuery, useUpdatedemandemessageMutation } from "../../../redux/slice/api/FO/messageApi";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import { IFormMessageDemande } from "../../../components/IFormMessage";
import { toast } from "react-toastify";
import { IMessage } from "../../../models/interfaces/IMessage";

import CpntDetailsNotAccess, { TypeAffichage } from "../../../components/CpntDetailsNotAccess";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";
import CpntNavigatorSociete from "../components/CpntNavigatorSociete";



 
const PageMarqueDetailsMessageDemande: React.FC = () => {
  const [Actif, setActif] = useState(false);
  const [IdMessage, setIdMessage] = useState<number|null>(null);
  const [message, setMessage] = useState<IMessage|null>(null);


  const detail = () => {
    setActif(!Actif);
  }


  const navigate = useNavigate();
  const { idmarque:idmarqueUrl, idmessage:idmessageUrl } = useParams();
  const idmarqueValue = idmarqueUrl ?? "";
  const idmessageValue = idmessageUrl ?? "";
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();

  const [triggerGetMessage, { data: MessageResult, isFetching: isFetchingMessage, error: Messageerror }] = useLazyFetchmessageQuery();

  const { data: MarqueResult, isFetching } = useFetchSocieteQuery(idmarqueValue, {
  refetchOnMountOrArgChange: true,
  skip: !keycloakinitialized || !keycloak.authenticated || idmarqueValue === null || idmarqueValue === "",
  });

    

  useEffect(() => {
    MessageResult?.Message && setMessage(MessageResult?.Message);
  }, [MessageResult])


  useEffect(() => {
    !isNaN(Number(idmessageValue)) && setIdMessage(Number(idmessageValue));
  }, [idmessageValue]);


  useEffect(() => {
    if (keycloakinitialized && keycloak.authenticated && IdMessage) {
      triggerGetMessage(IdMessage);
    }
  }, [keycloakinitialized, keycloak.authenticated, IdMessage, triggerGetMessage]);


  
  const [
    updateDemandeMessage,
    {
    //isSuccess: isSuccessUpdatedemandeMessage,
    error: errorUpdatedemandeMessage,
    reset: resetUpdatedemandeMessage
  }] = useUpdatedemandemessageMutation();

  const [
    createDemandeMessage,
    {
    //isSuccess: isSuccessCreatedemandeMessage,
    error: errorCreatedemandeMessage,
    reset: resetCreatedemandeMessage
  }] = useCreatemessageMutation();


  const [
    deleteMessage, {
    //isSuccess: isSuccessDeleteMessage,
    error: errorDeleteMessage,
    reset: resetDeleteMessage
  }] = useDeletemessageMutation();
  

  const handleSupprimerDemande = async (idMessage:number) => {

    const response = await deleteMessage(idMessage).unwrap();
    if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
      resetDeleteMessage();
      response.Return_Message &&
      toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
    } else if (response.Return_IdType_Message === Type_Return_Message.Validation) {
      setMessage(null);
      resetDeleteMessage();
      toast.success("La demande a été supprimée avec succès");
      navigate(`/messagesmarques/marquedetailsmessage/${idmarqueValue}`, { replace: false });
    }
  }

  const handleCreateDemande = async (data:IFormMessageDemande) => {
        const response = await createDemandeMessage(
          {
            IdTypeDemande: data.IdTypeDemande?? -1,
            MessageDemande:data.MessageDemande,
            IdMarque: Number(idmarqueValue),
          }
        ).unwrap();
     
        if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
          resetCreatedemandeMessage();
          response.Return_Message &&
          toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
        } else if (!isNaN(Number(response?.Message.Id))) {
          setMessage(response?.Message);
          resetCreatedemandeMessage();
          toast.success(<div dangerouslySetInnerHTML={{ __html: "Votre demande de correction a bien été prise en compte." }} />);
          navigate(`/messagesmarques/marquedetailsmessage/${idmarqueValue}/${response?.Message?.Id}`, { replace: false });
        }

      //}
  }
  
  const handleUpdateDemande = async (data:IFormMessageDemande) => {

    //if (MessageResult !== undefined && MessageResult?.Id !== undefined && MessageResult.Id > 0) {
      if (message && message?.Id !== undefined && message.Id > 0) {
     //UPDATE
     const response = await updateDemandeMessage(
       {
         //...data,
         Id:message && message.Id ? message.Id : -1,
         IdTypeDemande: data.IdTypeDemande?? -1,
         MessageDemande:data.MessageDemande,
         IdMarque: Number(idmarqueValue)
       }
     ).unwrap();

     if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
      resetUpdatedemandeMessage();
      response.Return_Message &&
       toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
     } else if (!isNaN(Number(response?.Message.Id))) {
       setMessage(response?.Message);
       resetUpdatedemandeMessage();
       toast.success(<div dangerouslySetInnerHTML={{ __html: "Votre demande de correction a bien été prise en compte." }} />,);
       navigate(`messagesmarques//marquedetailsmessage/${idmarqueValue}/${response?.Message?.Id}`, { replace: false });
     }

     }
 }

  if (errorUpdatedemandeMessage || errorCreatedemandeMessage || errorDeleteMessage) {
    //
  } 

  if (Messageerror) {
    return (
      <div>Error</div>
    );
  } 

  if (isFetchingMessage || isFetching) {
    return (
  <SpinnerEditeurPro />
    )
  }

  const getNonAccessiblePart = (message?: string, jsxContent?: JSX.Element) => {
    return (
      // <div className="container">
      // <div className="row">
      //     <div className="col-9 mt-2 d-flex justify-content-start">
      //     {<>Votre contact :&nbsp;<b>{MarqueResult?.SuiviPar ? MarqueResult?.SuiviPar : 'biblio@electre.com'}</b></>} 
      //     </div>
          
      //     {
      //       getNavigator()
      //     }
      //   </div>
      <CpntDetailsNotAccess text={message} jsxElement={jsxContent} typeAffichage={TypeAffichage.Societe} />
    // </div>
    )
  }

  const getNavigator = () => {

    return (
        <div className="col-3 mt-2 d-flex justify-content-end">
          <div className="me-2">
          <CpntNavigatorSociete
          currentValueIdMarque={idmarqueValue}
          currentValueIdMessage={idmessageValue}
          
          //MarqueResult?.Societe?.Id}
          datas={(() => {
            const storedData = localStorage.getItem("MarquesNavigator");
            try {
              const parsedData = storedData ? JSON.parse(storedData) : [];
              return Array.isArray(parsedData) ? parsedData : [];
            } catch {
              return [];
            }
          })()}
          />
          </div>
        </div>
    )
  }

  
  return (
    <>
      {
          <>
      <div className="container">
      <div className="row">
          <div className="col-9 mt-2 d-flex justify-content-start">
          {
              message && message?.Id ?
              <>Votre contact :&nbsp;<b>{message?.SuiviPar ? message?.SuiviPar : 'biblio@electre.com'}</b></>
              :
              <>Votre contact :&nbsp;<b>{MarqueResult?.SuiviPar ? MarqueResult?.SuiviPar : 'biblio@electre.com'}</b></>
            }
          </div>
          
          {
            getNavigator()
          }
        </div>
          {
          (MarqueResult?.Return_IdType_Message === Type_Return_Message.Erreur)?
          getNonAccessiblePart("Cette demande est rattachée à une marque qui ne fait plus partie de votre périmètre de consultation.")
          :
          !Actif ? 
            <>
                <div className="row">
                    <div className="col-12 mt-2">
                      <MarqueDetailsPreview MarqueResult={MarqueResult} isFetchingMarqueResult={isFetching} ></MarqueDetailsPreview>
                    </div>
                </div>
                <div onClick={detail} style={{cursor:"pointer",backgroundColor:"#efefef"}} className="card btn btn-grey mt-1">
                  <div className="row">
                      <i className="col-12 bi-caret-down-fill"></i>
                  </div>
                </div>
            </> 
            :  
            <>
            {/* navigatorPath={"../marquedetailsmessage/"} */}
              <MarqueDetails MarqueResult={MarqueResult} isFetchingMarqueResult={isFetching} btnModifierVisible={false} ></MarqueDetails>
              <div onClick={detail} style={{cursor:"pointer",backgroundColor:"#efefef"}} className="card btn btn-grey mt-1">
                <div className="row">
                    <i className="col-12 bi bi-caret-up"></i>
                </div>
              </div>
            </>
          }
        </div>
        {
          (MarqueResult?.Return_IdType_Message === Type_Return_Message.Erreur)
          && (!message?.Id || (message?.IdTypeReponse && message?.IdTypeReponse < Type_Reponse_Message.TraitementEnCours)) 
          ? <></> 
          :
      <div className="row mt-2" style={{ textAlign: 'left' }}>
        <MessageView key={`D${message?.Id ?? 'new'}`} supprimerDemande={handleSupprimerDemande} enregistrerDemande={message ? handleUpdateDemande : handleCreateDemande} Message={message ? message : undefined} typeView={MessageTypeView.Demande} typeDemande={MessageTypeDemande.Societe} />
        <MessageView key={`R${message?.Id ?? 'new'}`} Message={message ? message : undefined} typeView={MessageTypeView.Reponse} typeDemande={MessageTypeDemande.Societe} />
      </div>
       }
      </>
    } 
    </>
    
  );

};
 
export default PageMarqueDetailsMessageDemande;
 